import { render, staticRenderFns } from "./TourGuide.vue?vue&type=template&id=06478ce2"
import script from "./TourGuide.vue?vue&type=script&lang=js"
export * from "./TourGuide.vue?vue&type=script&lang=js"
import style0 from "./TourGuide.vue?vue&type=style&index=0&id=06478ce2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports